
const NS = 'TimeListPopoverComponent';

// requiring html templates so that hot reloading works
const template = require('./timeListPopover.component.html');

export default {
  bindings: {
    /**
     * Object with following props
     * - `bookings` {number}
     * - `covers` {number}
     * - `intervalCovers` {number}
     * - `seated` {number}
     * - `due` {number} if set to null, will show dashes
     */
    bookingCounts: '<'
  },
  template,
  controllerAs: 'vm',
  controller
};

// just exported for unit tests
export function controller() {
  "ngInject";

  const vm = this;

  vm.getDue = getDue;


  function getDue() {
    if (!vm.bookingCounts.due) {
      return '-';
    }

    return `${vm.bookingCounts.seated}&nbsp;|&nbsp;${vm.bookingCounts.due}`;
  }
}
